import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { cn } from "@/lib/utils";
import { formatNumero, ordenarPor, type CidadeResolvida, type Metrica } from "./cidades";
import type { Variante } from "./KpiCards";

interface TopCidadesProps {
  cidades: CidadeResolvida[];
  metrica: Metrica;
  limite?: number;
  variante?: Variante;
}

export function TopCidades({ cidades, metrica, limite = 10, variante = "padrao" }: TopCidadesProps) {
  const top = ordenarPor(cidades, metrica).slice(0, limite);
  const tv = variante === "tv";
  const celula = tv ? "py-4 text-2xl" : undefined;
  const cabecalho = tv ? "text-xl text-slate-400" : undefined;

  if (top.length === 0) {
    return (
      <p className={cn("py-6 text-center", tv ? "text-2xl text-slate-400" : "text-sm text-muted-foreground")}>
        Nenhuma cidade no período.
      </p>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow className={tv ? "border-white/10 hover:bg-transparent" : undefined}>
          <TableHead className={cn("w-8", cabecalho)}>#</TableHead>
          <TableHead className={cabecalho}>Cidade</TableHead>
          <TableHead className={cn("text-right", cabecalho)}>Dispensações</TableHead>
          <TableHead className={cn("text-right", cabecalho)}>Farmácias</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {top.map((cidade, i) => (
          <TableRow key={cidade.codigoIbge} className={tv ? "border-white/10 hover:bg-white/5" : undefined}>
            <TableCell className={cn("text-muted-foreground", celula, tv && "text-slate-500")}>{i + 1}</TableCell>
            <TableCell className={cn("font-medium", celula)}>
              {cidade.nome}
              <span className={tv ? "text-slate-400" : "text-muted-foreground"}>/{cidade.uf}</span>
            </TableCell>
            <TableCell className={cn("text-right tabular-nums", celula, metrica === "dispensacoes" && "font-semibold")}>
              {formatNumero(cidade.dispensacoes)}
            </TableCell>
            <TableCell className={cn("text-right tabular-nums", celula, metrica === "farmacias" && "font-semibold")}>
              {formatNumero(cidade.farmacias)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
